import { apiPost, apiGet } from '../utils/api'
import Hotjar from '@hotjar/browser'

export function syncAPI(types) {
  Hotjar.event('sync_compliance')
  return apiPost(`mgmt/compliance/sync`, types)
}

export function getComplianceInventoryRoomsAPI() {
  return apiGet('mgmt/compliance/rooms')
}

export function getComplianceNalTaxOnlyAPI() {
  return apiGet('mgmt/compliance/tax/nalTaxOnly')
}

export function checkIfCDTFAEnabledAPI() {
  return apiGet('mgmt/compliance/ca/delivery/tax/check')
}

export function getStateCannabisDefinition(request) {
  return apiGet('mgmt/compliance/cannabisDefinitions', request)
}

export const limitV2ConfigAPI = (state) => {
  return apiGet(`mgmt/limits?state=${state}&type=LIMIT`);
}


// WEBPACK FOOTER //
// ./src/api/compliance.js